import { render, staticRenderFns } from "./SiteFile.vue?vue&type=template&id=b6c39920&"
import script from "./SiteFile.vue?vue&type=script&lang=js&"
export * from "./SiteFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports